import { IonContent, IonPage, IonItem, IonLabel, IonInput, useIonAlert } from '@ionic/react';
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLocalStorage } from 'beautiful-react-hooks';
import { useHistory } from 'react-router-dom';
import { motion } from 'framer-motion';
import { nanoid } from 'nanoid';

import axios from 'axios';
axios.defaults.headers.post['Access-Control-Allow-Origin'] = '*';

export default function SignIn() {
	const h = useHistory();
	const [present] = useIonAlert();
	const { iauid, otp, srv } = useParams();
	const [name, setName] = useState(null);
	const [email, setEmail] = useState(null);
	const [_, setSession] = useLocalStorage('session');

	const validate = (email) => {
		const re =
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
		return re.test(String(email.trim()).toLowerCase());
	};

	const submit = async () => {
		if (name && email) {
			if (validate(email)) {
				try {
					const user = nanoid();
					const payload = { name, email: email.trim(), user, otp };
					const base = srv === 'A' ? process.env.REACT_APP_API_A : process.env.REACT_APP_API_B;
					const result = await axios.post(`${base}/${iauid}/pair`, { ...payload });

					if (result.data) {
						const { token, uid: puid } = result.data;
						const _newsession = { ...payload, token, puid, srv };

						setSession(_newsession);
						setImmediate(() => h.push(`/B`));
					} else {
						// alert
						present({
							header: 'Atenção',
							message: 'Ocorreu um erro envio dos seus dados. Por favor tente mais tarde',
							buttons: ['ok'],
						});
					}
				} catch (error) {
					console.log('error', error);
					present({
						header: 'Atenção',
						message: 'Ocorreu um erro envio dos seus dados. Por favor tente mais tarde',
						buttons: ['ok'],
					});
				}
			} else {
				present({
					header: 'Atenção',
					message: 'Por favor verifique o email digitado',
					buttons: ['ok'],
				});
			}
		} else {
			present({
				header: 'Atenção',
				message: 'Por favor, preencha seu nome e seu email',
				buttons: ['ok'],
			});
		}
	};

	return (
		<IonPage>
			<IonContent fullscreen scrollY={true}>
				<div className='w-full min-h-full h-auto justify-items-center items-center flex flex-col bg-c-purple'>
					<img src={`/assets/media/tela-3-mobile-1.png`} alt='' className=' object-contain mt-12' />
					<IonItem lines='full' className='w-full mt-12 px-8' mode='ios'>
						<IonInput placeholder='digite nome' value={name} position='fixed' onIonChange={(e) => setName(e.detail.value)}></IonInput>
					</IonItem>
					<IonItem lines='full' className='w-full px-8 mt-2' mode='ios'>
						<IonInput placeholder='digite email' value={email} position='fixed' onIonChange={(e) => setEmail(e.detail.value)}></IonInput>
					</IonItem>
					<motion.img src='/assets/media/bt-send.png' alt='' className='mt-12 h-16' onTap={submit} />
				</div>
			</IonContent>
		</IonPage>
	);
}
